import clsx from 'clsx';
import NextImage from 'next/image';
import FooterImageBottomMobi from 'components/assets/FooterImageBottomMobi.png';
import Mobiworkxlogo from 'components/assets/MobiworkxLogo.svg'; // Adjust the import path as necessary
import ExternalLink from 'components/atoms/ExternalLink/ExternalLink';
import Heading from 'components/atoms/Heading/Heading';
import Txt from 'components/atoms/Txt/Txt';
import { useIsLoggedIn } from 'components/templates/AuthenticationProvider/AuthenticationProvider';
import React from 'react';
import { useMediaQuery } from 'react-responsive';
import classes from './Footer.module.scss';
import LoggedInFooterMenu from './LoggedInFooterMenu';
import { useRouter } from 'next/router';
import { LanguageLinkProps, mobileLanguageLinks } from './MultilingualFooterLinks';

import A from 'components/atoms/A/A';

export interface Props {
  theme?: string | string[];
}

const Footer: React.FC<Props> = ({ theme }) => {
  const isLoggedIn = useIsLoggedIn();
  const isDesktop = useMediaQuery({ query: '(min-width: 768px)' });
  // const hasAndroid = !!useExternalLink('google-play');
  // const hasiOS = !!useExternalLink('apple-store');
  // const [, setConsentStatus] = useCookieConsentStatus();
  const { locale } = useRouter();

  // Links filtered by the current locale
  const langLinksTwo = mobileLanguageLinks[locale || 'en'] || mobileLanguageLinks['en'];

  function getFooterHref(langLinksTwo: LanguageLinkProps[], label: string) {
    return langLinksTwo.find((link) => link.label === label)?.href || '#';
  }

  const footerLinks = (
    <>
      <div className={classes.footerContainer}>
        <div className={classes.footerDetails}>
          <nav className={classes.socialMedia}>
            <Heading level={5}>SOCIAL</Heading>
            <ExternalLink link="blog" href="#" target="_blank">
              <Txt>Blog</Txt>
            </ExternalLink>
          </nav>

          <nav className={classes.topArticles}>
            <Heading level={5}>TOP ARTICLES</Heading>
            <ExternalLink link="how-to-survey" href="https://mobiworkx.com/Articles/SurveyPay">
              <Txt>Surveys that pay</Txt>
            </ExternalLink>
            <ExternalLink link="how-to-money" href="https://mobiworkx.com/Articles/MakeMoney">
              <Txt>Make money online</Txt>
            </ExternalLink>
          </nav>

          <nav className={classes.needHelp}>
            <Heading level={5}>HELP & SUPPORT</Heading>
            <ExternalLink link="help" href={process.env.NEXT_PUBLIC_HELPCENTER_URL || ''}>
              <Txt>Contact Support</Txt>
            </ExternalLink>
          </nav>
          <nav className={classes.privacy}>
            <Heading level={5}>PRIVACY & TERMS</Heading>
            <A href={getFooterHref(langLinksTwo, "Membership T&C's")} target="_blank">
              <Txt>Membership T&C&apos;s</Txt>
            </A>
            <A href={getFooterHref(langLinksTwo, 'Panel Privacy Policy')} target="_blank">
              <Txt>Panel privacy policy</Txt>
            </A>
            <A href={getFooterHref(langLinksTwo, 'Rewards Program Terms')} target="_blank">
              <Txt>Rewards program terms</Txt>
            </A>
          </nav>
        </div>

        <div className={classes.footerLogoColumn}>
          <div className={classes.footerLogo}>
            <Mobiworkxlogo width={150} height={50} className={classes.footerLogo} />
          </div>
          <div className={classes.footerCopyright}>
            <Txt component="p"> © {{ copyright: new Date().getFullYear() }} Mobiworkx </Txt>
          </div>
        </div>
      </div>

      <div className={classes.footerBottomImage}>
        <NextImage
          src={FooterImageBottomMobi}
          alt={'footer image'}
          className={classes.footerLogo}
        />
      </div>
    </>
  );

  const footerMenu = <LoggedInFooterMenu />;

  const conditionalFooter = () =>
    isLoggedIn ? (isDesktop ? footerLinks : footerMenu) : footerLinks;

  return (
    <footer className={clsx(classes.root, 'hidden-when-embedded')}>{conditionalFooter()}</footer>
  );
};

export default Footer;
